import React, { createContext, useContext, useState, useCallback } from "react";
import { Message, Transition, Icon } from "semantic-ui-react";

const ToastContext = createContext();

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((type, message, duration = 4000) => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, type, message }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, duration);
  }, []);

  const contextValue = {
    success: (msg, dur) => showToast("success", msg, dur),
    error: (msg, dur) => showToast("error", msg, dur),
    info: (msg, dur) => showToast("info", msg, dur),
    warning: (msg, dur) => showToast("warning", msg, dur),
  };

  // ikona podľa typu
  const getIcon = (type) => {
    switch (type) {
      case "success": return "check circle";
      case "error": return "times circle";
      case "warning": return "exclamation triangle";
      default: return "info circle";
    }
  };

  return (
    <ToastContext.Provider value={contextValue}>
      {children}

      {/* Toast Container */}
      <div
        style={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 3000,
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          pointerEvents: "none", // neblokuje kliknutia v UI
        }}
      >
        {toasts.map((toast) => (
          <Transition
            key={toast.id}
            visible
            animation="fade up"
            duration={400}
          >
            <div
              style={{
                pointerEvents: "auto",
                minWidth: "260px",
                maxWidth: "380px",
              }}
            >
              <Message
                color="yellow"
                floating
                style={{
                  margin: 0,
                  boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
                  borderRadius: "10px",
                  fontSize: "0.95rem",
                  display: "flex",
                  alignItems: "center",
                  padding: "12px 16px",
                }}
              >
                <Icon
                  name={getIcon(toast.type)}
                  size="large"
                  style={{ marginRight: "10px" }}
                />
                <div style={{ flex: 1 }}>{toast.message}</div>
              </Message>
            </div>
          </Transition>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error("useToast must be used inside <ToastProvider>");
  }
  return ctx;
}
